import styled from '@emotion/styled';
import { Fonts, mediaQuery, Spacings } from '@styles/index';
import Paper from 'aquilla/core/atoms/Paper';
import Typography from 'aquilla/core/atoms/Typography';
import CheckContained from 'aquilla/icons/misc/CheckContained';
import { useIsMobile } from '@stores/AppCommonData';
import Image from '@base/FutureImage';
import useCompeteInfo from '../useCompeteInfo';

const Wrapper = styled.div`
  margin-top: ${Spacings.SPACING_16B};
  overflow: hidden;
  width: 100%;
  ${mediaQuery.uptoMobile} {
    margin-top: ${Spacings.SPACING_10B};
  }
`;

const ContentWrapper = styled(Paper)`
  margin-top: ${Spacings.SPACING_6B};
  display: flex;
  border: 1px solid var(--color-divider);
  border-radius: 8px;
  justify-content: space-between;

  ${mediaQuery.uptoMobile} {
    flex-direction: column-reverse;
    margin-top: ${Spacings.SPACING_4B};
  }
`;

const Info = styled.div`
  display: flex;
  flex-direction: column;
  padding: ${Spacings.SPACING_6B};
  padding-right: 0;
  ${mediaQuery.uptoMobile} {
    padding: ${Spacings.SPACING_4B};
    padding-top: 0;
  }
`;

const ListItem = styled.div`
  font-weight: ${Fonts.REGULAR};
  font-size: ${Fonts.H5};
  line-height: 22px;
  display: flex;
  align-items: center;
  margin-left: ${Spacings.SPACING_2B};

  ${mediaQuery.uptoMobile} {
    font-size: ${Fonts.H6};
    line-height: 20px;
    margin-left: ${Spacings.SPACING_6};
  }
`;

const Flex = styled.div`
  display: flex;

  &:not(:first-child) {
    margin-top: ${Spacings.SPACING_3B};
  }
`;

const ImageWrapper = styled.div`
  width: 190px;
  height: 180px;
  position: relative;
  ${mediaQuery.uptoMobile} {
    width: 100%;
    height: 120px;
    object-fit: center;
    margin-bottom: ${Spacings.SPACING_4B};
    border: 1px solid var(--color-divider);
  }
`;

const desktopImage = '/compete/compete-banner-desktop.svg';
const mwebImage = '/compete/compete-banner-mweb.svg';

const HowCompeteWorksCard = () => {
  const isMobile = useIsMobile();
  const { info } = useCompeteInfo();

  if (!info) {
    return null;
  }

  return (
    <Wrapper>
      <Typography variant={isMobile ? 'h5' : 'h4'}>
        How Compete works
      </Typography>
      <ContentWrapper>
        <Info>
          {info?.map((item, index) => (
            // eslint-disable-next-line react/no-array-index-key
            <Flex key={index}>
              <CheckContained
                width={24}
                height={24}
                color="var(--color-i-blue)"
              />
              <ListItem>{item}</ListItem>
            </Flex>
          ))}
        </Info>
        <ImageWrapper>
          <Image
            src={isMobile ? mwebImage : desktopImage}
            alt="badges"
            layout="fill"
          />
        </ImageWrapper>
      </ContentWrapper>
    </Wrapper>
  );
};

export default HowCompeteWorksCard;
